import Vue from 'vue'
import Vuex from 'vuex'

import vuejsStorage from 'vuejs-storage'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'mmpRoute'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        route: {}
      },
      plugins: [
        vuejsStorage({
          keys: ['route'],
          namespace: 'mmp-app-route',
          driver: vuejsStorage.drivers.sessionStorage
        })
      ]
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/mmpRoute.js